<template>
  <modal v-if="isVisible">
    <template v-slot:header>
      <h5 class="modal-title">{{$t('form.signature-check.title')}}</h5>
    </template>

    <template v-slot:body>
      <div>
        <blockquote>
          <div v-html="signedData"></div>
          <button class="gui-btn gui-btn--link" @click.prevent="saveTextAs(signedData, 'signed-data.txt')">{{$t('form.signature-check.download-signed-data')}}</button>
        </blockquote>
        <template v-for="cert in certificates">
          <div>
            <p><i>{{$t('form.signature-check.serial-number')}}</i>: {{cert.serial}}</p>
            <p><i>{{$t('form.signature-check.owner')}}</i>: {{cert.owner}}</p>
            <p><i>{{$t('form.signature-check.valid-until')}}</i>: <date-time tag="span" :value="cert.validUntil"></date-time></p>
          </div>
        </template>
        <button class="gui-btn gui-btn--link" @click.prevent="saveTextAs(signature, 'signature.txt')">{{$t('form.signature-check.download-signature')}}</button>
      </div>
    </template>

    <template v-slot:footer>
      <button class="gui-btn gui-btn--red gui-btn--ep" @click.prevent="close" v-t="'buttons.ok'"></button>
    </template>
  </modal>
</template>

<script>
  export default {
    data: () => ({
      isVisible: false,
      signedData: undefined,
      certificates: undefined,
      signature: undefined
    }),

    methods: {
      open({ data, certificates, signature }) {
        this.signedData = data;
        this.certificates = certificates.map(e => ({
          serial: e.serial,
          owner: e.subject,
          validUntil: e.time
        }));
        this.signature = signature;
        this.isVisible = true;
      },

      close() {
        this.isVisible = false;
        this.$emit('close');
      }
    }
  }
</script>

<style lang="scss" scoped>
  blockquote {
    background-color: #f7f7f7;
    padding: 20px;
    margin-bottom: 20px;

    &>div {
      max-height: 200px;
      overflow-y: auto;
    }
  }
</style>
